import { apiV2 } from "../v2";
import {
  deleteAdminAuthorIdeasRequest,
  deleteAdminAuthorIdeasResponse,
  listAdminIdeasRequest,
  listAdminIdeasResponse,
  resetAdminIdeasRequest,
  resetAdminIdeasResponse,
} from "./ideas.dto";

export const listAdminIdeasApi = apiV2("GET", "/admin/ideas").withRequest(listAdminIdeasRequest).withResponse(listAdminIdeasResponse);

export const resetAdminIdeasApi = apiV2("POST", "/admin/ideas/reset-status").withRequest(resetAdminIdeasRequest).withResponse(resetAdminIdeasResponse);

/** Deletes the author's ideas that have no article and sends the author back to `pending_idea`. */
export const deleteAdminAuthorIdeasApi = apiV2("DELETE", "/admin/authors/:alias/ideas")
  .withRequest(deleteAdminAuthorIdeasRequest)
  .withResponse(deleteAdminAuthorIdeasResponse);
